import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

const HeroSectionEn = ({
  onExplore
}: {
  onExplore?: () => void;
}) => {
  return (
    <section className="relative min-h-[50vh] bg-black text-white overflow-hidden">
      {/* Add top padding to clear the fixed header */}
      <div className="relative z-10 flex items-center min-h-[50vh] pt-20 md:pt-24">
        <div className="w-full px-8 md:px-16 lg:px-24">
          <div className="max-w-7xl mx-auto">
            <div className="text-center animate-on-scroll pt-2 md:pt-3 lg:pt-4">
              <h1 className="hero-title text-3xl md:text-4xl lg:text-5xl xl:text-6xl mb-8 leading-tight">
                <span className="text-white">The World's Best </span><br />
                <span className="bg-gradient-to-r from-[#67fefe] to-[#0a04f5] bg-clip-text text-transparent">Startup Nation Begins with </span>
                <span className="text-[hsl(var(--brand-sky-blue))] drop-shadow-sm">Knowledge</span>
              </h1>
              <p className="text-lg lg:text-xl mb-8 text-white/90 leading-relaxed max-w-5xl mx-auto">Sweden Startup Nation (SSN) is an independent national actor that strengthens Sweden's innovation capacity by collecting, analyzing, and making data on startups and scaleups accessible -  to highlight their impact, close knowledge gaps, and create better conditions for growth.</p>
              <div className="flex flex-col sm:flex-row gap-8 justify-center mb-8">
                <Button size="lg" variant="cyan" className="hidden px-12 py-6 text-xl font-bold rounded-full" onClick={onExplore}>
                  Explore Data
                  <ArrowRight className="ml-3 h-6 w-6" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSectionEn;
